export default __webpack_public_path__ + "static/media/single-arrow.1788e304.svg";